/** @jsx h **/
import { defineComponent, onMounted, onUnmounted, ref, inject, h } from "vue";
import {
  getBufferIcon,
  getBufferRouteURL,
  getBufferTitle,
  ShellProps,
  ShellPropsList,
} from "@gratico/kernel";
import { useRouter, RouterLink } from "vue-router";

export const Tabs = defineComponent<ShellProps>({
  name: "Tabs",
  props: ShellPropsList,
  setup(props) {
    const router = useRouter();
    const container = ref(null);
    let cleanup: Function | null = null;

    const routerHandler = () => {
      // console.log("route changed");
    };

    onMounted(() => {
      if (container.value) {
        // cleanup = createSortable(container.value.parentElement);
      }
      router?.options.history.listen(routerHandler);
    });

    onUnmounted(() => {
      if (cleanup) cleanup();
      // Vue Router doesn't support removing listeners directly
    });

    return () => (
      <div>
        <div
          role="tablist"
          style="scrollbar-width: none;"
          class="flex h-full w-full overflow-x-auto"
          ref={container}
        >
          {props.buffers.map((cursor) => {
            const buffer = cursor();
            const isActive = props.$buffers.activeBufferId === buffer.id;
            return (
              <div
                role="tab"
                style={
                  isActive
                    ? "background: #ffffff08; border-color: dodgerblue;"
                    : ""
                }
                class="flex px-2 py-2 border-b-2 border-transparent glossy-bg"
              >
                <div
                  style="width: 20px"
                  class="flex items-center justify-center"
                >
                  <img
                    data-fileicon="true"
                    style="width: 20px"
                    src={getBufferIcon(buffer)}
                  />
                </div>
                <RouterLink
                  class="flex items-center justify-center pl-2 truncate text-sm"
                  to={getBufferRouteURL(buffer)}
                >
                  {getBufferTitle(buffer)}
                </RouterLink>
                {/* {false && <i class="ri-asterisk text-sm"></i>} */}
              </div>
            );
          })}
        </div>
      </div>
    );
  },
});

export const TabsIsland = defineComponent<ShellProps>({
  name: "TabsIsland",
  props: ShellPropsList,
  setup(props) {
    return () => (
      <div
        style="height: 40px; z-index: 214748364; left: 80px; right: 80px;"
        class="flex layered-bg absolute top-0 left-8 right-8 border rounded-r rounded-l border-t-0"
      >
        <div
          key="tabs"
          style="scrollbar-width: none;"
          class="flex flex-1 overflow-x-auto"
        >
          <Tabs {...props} />
        </div>
        <div class="pl-2 py-2 flex justify-center items-center">
          <div class="flex text-sm px-1">
            <div
              style="background: #222; border: 1px solid var(--component-border-color);"
              class="bg-white text-white mr-1 px-1 rounded uppercase"
            >
              SPC
            </div>
            <span class="mx-1">
              <i class="ri-keyboard-box-fill"></i>
            </span>
          </div>
          <div class="flex text-sm px-1 hidden">
            <div
              style="background: #222; border: 1px solid var(--component-border-color);"
              class="bg-white text-white mr-1 px-2 rounded"
            >
              ⌘ + K
            </div>
            <span class="mx-1">OPEN FILE</span>
          </div>
        </div>
      </div>
    );
  },
});
